<template>
    <div class="card-container">
        <common-top-form
            :model="formModel"
            :submitService="submitService"
            :submitData="submitData"
            @success="onSuccess"
            @openAddDialog="openAddDialog"
            :show="false"
            :selectShow="false"
            addShowPower="/threevipapppointsnewodetojoymanage/add"
        >
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" :isShow="false">
            <el-table-column
                prop="id"
                label="序号"
                min-width="120"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="name"
                label="名称"
                min-width="220"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="buyAmount"
                label="支付金额(元)"
                min-width="220"
                :formatter="formatterTableNumber"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="agentMoney"
                label="代理商奖励(元)"
                min-width="220"
                :formatter="formatterTableNumberYuan"
                show-overflow-tooltip
            ></el-table-column>
            <!-- <el-table-column
              prop="planName"
              label="商户计划名称"
              min-width="220"
              :formatter="formatterTableData"
              show-overflow-tooltip
            ></el-table-column> -->
            <el-table-column
                prop="number"
                label="期数"
                min-width="120"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="dayNumber"
                label="每期天数"
                min-width="120"
                :formatter="formatterTableData"
                show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                prop="qualifiedTransactions"
                label="达标交易量(元)"
                min-width="120"
                :formatter="formatterTableNumberYuan"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="reward"
                label="每期奖励金(元)"
                min-width="120"
                :formatter="formatterTableNumberYuan"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="couponGroupName"
                label="优惠券"
                min-width="220"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
              <el-table-column
                prop="remarks"
                label="备注"
                min-width="120"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="status"
                label="状态"
                min-width="100"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <el-switch
                        v-model="scope.row.status"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-value="1"
                        inactive-value="0"
                        @change="statusturns($event, scope.row)"
                    />
                </template>
            </el-table-column>
            <el-table-column
                v-if="hasPerm('/threevipapppointsnewodetojoymanage/update')"
                label="操作"
                min-width="100"
                fixed="right"
            >
                <template slot-scope="scope">
                    <el-button
                        type="text"
                        v-if="hasPerm('/threevipapppointsnewodetojoymanage/update')"
                        @click="openAddDialog(scope.row)"
                    >修改
                    </el-button>
                </template>
            </el-table-column>
        </common-table>
        <form-dialog
            ref="formDialog"
            :formDialogTitle="itemId ? '修改' : '添加'"
            :model="dialogModel"
            :submitData="dialogData"
            :rules="dialogRules"
            :dialogService="dialogService"
            @close="dialogClose"
            @success="dialogSuccess"
            class="note"
            labelWidth="120px"
            dialogWidth="520px"
        >
            <el-form-item label-width="135px" label="名称" prop="name">
                <el-input
                    type="text"
                    maxlength="100"
                    v-model="dialogModel.name"
                    placeholder="请输入"
                    style="width: 250px"
                ></el-input>
            </el-form-item>
            <!-- <el-form-item label-width="135px" label="商户计划名称" prop="planName">
              <el-input
                type="text"
                maxlength="100"
                v-model="dialogModel.planName"
                placeholder="请输入"
                style="width: 250px"
              ></el-input>
            </el-form-item> -->
            <el-form-item label-width="135px" label="支付金额(元)" prop="buyAmount">
                <el-input-number
                    v-model="dialogModel.buyAmount"
                    :min="0"
                    :max="999999999"
                    :step="0.1"
                    :precision="2"
                    :controls="false"
                    placeholder="请输入"
                    style="width: 250px"
                ></el-input-number>
            </el-form-item>
            <el-form-item
                label-width="135px"
                label="代理商奖励(元)"
                prop="agentMoney"
            >
                <el-input-number
                    v-model="dialogModel.agentMoney"
                    :min="0"
                    :max="999999999"
                    :step="0.1"
                    :precision="2"
                    :controls="false"
                    placeholder="请输入"
                    style="width: 250px"
                ></el-input-number>
            </el-form-item>
            <el-form-item label-width="135px" label="期数" prop="number">
                <el-input-number
                    v-model="dialogModel.number"
                    :min="1"
                    :max="999999999"
                    :step="0"
                    :precision="0"
                    :controls="false"
                    placeholder="请输入"
                    style="width: 250px"
                ></el-input-number>
            </el-form-item>
            <el-form-item label-width="135px" label="每期天数" prop="dayNumber">
                <el-input-number
                    v-model="dialogModel.dayNumber"
                    :min="1"
                    :max="999999999"
                    :step="0"
                    :precision="0"
                    :controls="false"
                    placeholder="请输入"
                    style="width: 250px"
                ></el-input-number>
            </el-form-item>
            <el-form-item
                label-width="135px"
                label="达标交易量(元)"
                prop="qualifiedTransactions"
            >
                <el-input-number
                    v-model="dialogModel.qualifiedTransactions"
                    :min="0"
                    :max="999999999"
                    :step="0.1"
                    :precision="2"
                    :controls="false"
                    placeholder="请输入"
                    style="width: 250px"
                ></el-input-number>
            </el-form-item>
            <el-form-item label-width="135px" label="每期奖励金(元)" prop="reward">
                <el-input-number
                    v-model="dialogModel.reward"
                    :min="0"
                    :max="999999999"
                    :step="0.1"
                    :precision="2"
                    :controls="false"
                    placeholder="请输入"
                    style="width: 250px"
                ></el-input-number>
            </el-form-item>
            <el-form-item label="优惠券" label-width="135px" prop="couponGroupId">
                <el-select v-model="dialogModel.couponGroupId" placeholder="请选择" style="width: 250px">
                    <el-option
                        v-for="item in couponList"
                        :key="item.id"
                        :label="item.groupName"
                        :value="item.id"
                        style="width: 250px"
                    ></el-option>
                </el-select>
            </el-form-item>
            <!-- 新增 -->
               <el-form-item label-width="135px" label="备注" prop="remarks">
                <el-input
                 
                     maxlength="200"
                    type="textarea"
          rows="3"
                    v-model="dialogModel.remarks"
                    placeholder="请输入"
                    style="width: 250px"
                ></el-input>
            </el-form-item>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import FormDialog from "../../dialog/FormDialog";

    import TransactionService from "service/TransactionService";

    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from "vuex";

    export default {
        name: "twovipapppointsnewodetojoymanage",
        components: {
            CommonTopForm,
            CommonTable,
            FormDialog,
        },
        data() {
            return {
                show: false,
                formModel: {},
                tableData: [],
                submitService: TransactionService.ThreezxList,
                itemId: "",
                dialogModel: {
                    name: "",
                    // planName: "",
                    number: "1",
                    buyAmount: undefined,
                    agentMoney: undefined,
                    qualifiedTransactions: undefined,
                    reward: undefined,
                    dayNumber: 1,
                    couponGroupId: '',
                    remarks: ''
                    
                },
                dialogRules: {
                       remarks: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    name: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    number: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    buyAmount: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    agentMoney: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    qualifiedTransactions: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    reward: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    dayNumber: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    couponGroupId: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                },
                isFlag: false,
                currentTypes: {},
                couponList: []
            };
        },
        inject: ["reload"],
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.load();
        },
        computed: {
            submitData() {
                this.params = {};
                return this.params;
            },
            dialogData() {
                const params = {
                    name: this.dialogModel.name,
                    // planName: this.dialogModel.planName,
                    number: this.dialogModel.number,
                    buyAmount: this.dialogModel.buyAmount * 100,
                    agentMoney: this.dialogModel.agentMoney,
                    qualifiedTransactions: this.dialogModel.qualifiedTransactions,
                    reward: this.dialogModel.reward,
                    dayNumber: this.dialogModel.dayNumber,
                    couponGroupId: this.dialogModel.couponGroupId,
                    remarks: this.dialogModel.remarks
                };
                if (this.itemId) {
                    params.id = this.itemId;
                }
                return params;
            },
            dialogService() {
                return TransactionService.ThreezxEdit;
            },
            ...mapGetters(["serverType", "tatId", "userId"]),
        },
        watch: {},
        methods: {
            load() {
                this.formModel = {};
                this.getList();
                this.getCouponList();
            },
            getCouponList() {
                this.doLoad(TransactionService.coupongroupmanageList, {
                        size: 100
                    },
                    (res) => {
                        this.couponList = res.contents.rows;
                    },
                    "信息获取失败"
                );
            },
            getList() {
                this.doLoad(
                    this.submitService,
                    this.submitData,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.onSuccess(res);
                        });
                    },
                    "信息获取失败"
                );
            },
            statusturns($event, scope) {
                this.doStatus($event, scope);
            },
            doStatus($event, scope) {
                this.doLoad(
                    TransactionService.ThreezxStatus,
                    {
                        id: scope.id,
                        status: $event,
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.commonSuccess(res);
                        });
                    },
                    "操作失败"
                );
            },
            openAddDialog(item, flag) {
                this.itemId = item ? item.id : "";
                if (this.itemId) {
                    this.isFlag = true;
                    this.dialogModel = JSON.parse(JSON.stringify(item));
                    this.dialogModel.buyAmount = this.dialogModel.buyAmount / 100;
                    this.dialogModel.couponGroupId = Number(this.dialogModel.couponGroupId )
                }
                this.$refs.formDialog.open();
            },

            dialogClose() {
                this.dialogModel = {
                    name: "",
                    // planName: "",
                    number: "1",
                    buyAmount: undefined,
                    agentMoney: undefined,
                    qualifiedTransactions: undefined,
                    reward: undefined,
                    remarks: '',
                    dayNumber: 1,
                };
                this.itemId = "";
            },
            dialogSuccess(res) {
                this.commonSuccess(res);
                this.$refs.formDialog.closeDialog();
            },
            commonSuccess(res) {
                this.showSuccess(res.respMsg);
                this.getList();
            },
            onSuccess(res) {
                this.doCheck(res, (res) => {
                    const result = res.contents;
                    this.tableData = result;
                });
            },
            formatterTableCoupon(row, column, cellValue, index) {
                let value = "--";
                this.couponList.forEach((item) => {
                    if (item.id == cellValue) {
                        value = item.groupName
                    }
                });

                return value;
            },
        },
    };
</script>

<style scoped>
    .button {
        width: 50px;
        padding: 11px 10px;
        margin-left: 49px;
        display: block;
        float: left;
    }

    .text {
        width: 145px !important;
        margin-left: 12px;
        float: left;
    }

    .mem-name p {
        margin-bottom: 20px;
        vertical-align: middle;
        line-height: 40px;
        color: rgba(170, 170, 170, 1);
    }

    .mem-name p:first-child {
        display: inline-block;
        width: 90px;
        text-align: right;
        vertical-align: middle;
        font-size: 14px;
        color: #606266;
        line-height: 40px;
    }

    .chenk {
        width: 60px;
        position: relative;
        top: -61px;
        left: 189px;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar {
        width: 100px;
        height: 100px;
        display: block;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
    }

    .iconUrl {
        width: 50px;
        height: 50px;
        margin: auto;
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/ThreeVipAppPointsNewOdeToJoyManage.vue